// extracted by mini-css-extract-plugin
export default {"section_container":"inside-look_section_container__CBtvy","caption":"inside-look_caption__94KkO","section_title":"inside-look_section_title__1f0RH"};